var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header" },
      [
        _c("h5", { staticClass: "mb-0 d-inline" }, [
          _vm._v("\n            " + _vm._s(_vm.name) + "\n        ")
        ]),
        _vm._v(" "),
        _vm.running
          ? _c(
              "button",
              {
                staticClass: "btn btn-danger collapsed float-right",
                staticStyle: { margin: "0 .5rem" },
                attrs: {
                  "aria-expanded": "false",
                  "aria-controls": "collapseTwo"
                },
                on: { click: _vm.stop }
              },
              [_vm._v("\n            Stop\n        ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-success collapsed float-right",
            staticStyle: { margin: "0 .5rem" },
            attrs: {
              disabled: _vm.running,
              "aria-expanded": "false",
              "aria-controls": "collapseTwo"
            },
            on: { click: _vm.run }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.running ? "Running..." : "Run") +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _vm.hasArguments && !_vm.hideArguments
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary collapsed float-right",
                staticStyle: { margin: "0 .5rem" },
                attrs: {
                  "aria-expanded": "false",
                  "aria-controls": "collapseTwo"
                },
                on: { click: _vm.toggle }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.showing ? "Hide" : "Show") +
                    "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.progressSteps, function(step) {
          return _vm.progress
            ? _c("div", [
                _c("p", { staticClass: "mt-2 d-block" }, [
                  _c("small", {
                    domProps: {
                      innerHTML: _vm._s(
                        "<b>Step %t:</b> %s (%d%)"
                          .replace("%t", step.index)
                          .replace("%s", step.message || "Done!")
                          .replace("%d", step.percentage)
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.progress
                  ? _c("div", { staticClass: "progress mb-3" }, [
                      _c("span", {
                        class: [
                          "progress-bar",
                          "d-block",
                          step.status == "finished" ? "success" : "",
                          step.status == "stopped" ? "warning" : ""
                        ],
                        style: "width: " + step.percentage + "%;"
                      })
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        })
      ],
      2
    ),
    _vm._v(" "),
    !_vm.hideArguments
      ? _c(
          "div",
          {
            class: ["collapse", _vm.showing ? "show" : ""],
            attrs: { "aria-labelledby": "headingOne" }
          },
          [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm._l(_vm.args, function(entry) {
                  return [
                    entry.type == "string"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label: _vm.__(entry.name, ["titleCase"]) + ":",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    value: _vm._.get(
                                      _vm.settings,
                                      entry.name,
                                      entry.default
                                    ),
                                    autocomplete: "off",
                                    required: entry.required
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(entry.name, value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    entry.type == "array"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label: _vm.__(entry.name, ["titleCase"]) + ":",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    value: _vm._.get(
                                      _vm.settings,
                                      entry.name,
                                      entry.default
                                    ),
                                    autocomplete: "off",
                                    required: entry.required
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(entry.name, value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    entry.type == "boolean"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label: _vm.__(entry.name, ["titleCase"]) + ":",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("switches", {
                                  attrs: {
                                    value: _vm.getArgumentValue(entry),
                                    theme: "bootstrap",
                                    color: _vm.getArgumentValue(entry)
                                      ? "primary"
                                      : "default"
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(entry.name, value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }),
                _vm._v(" "),
                _vm._l(_vm.opts, function(entry) {
                  return [
                    entry.type == "string"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label:
                                _vm.__(entry.name, ["titleCase"]) +
                                "(optional):",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    value: _vm._.get(
                                      _vm.settings,
                                      entry.name,
                                      entry.default
                                    ),
                                    autocomplete: "off",
                                    required: entry.required
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(
                                        "--" + entry.name,
                                        value
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    entry.type == "array"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label:
                                _vm.__(entry.name, ["titleCase"]) +
                                "(optional):",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    value: _vm._.get(
                                      _vm.settings,
                                      entry.name,
                                      entry.default
                                    ),
                                    autocomplete: "off",
                                    required: entry.required
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(
                                        "--" + entry.name,
                                        value
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    entry.type == "boolean"
                      ? _c(
                          "b-form-group",
                          {
                            key: entry.name,
                            attrs: {
                              label:
                                _vm.__(entry.name, ["titleCase"]) +
                                " (optional):",
                              description: entry.description || "",
                              "label-for": entry.name,
                              horizontal: ""
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("switches", {
                                  attrs: {
                                    value: _vm.getOptionValue(entry),
                                    theme: "bootstrap",
                                    color: _vm.getOptionValue(entry)
                                      ? "primary"
                                      : "default"
                                  },
                                  on: {
                                    input: function(value) {
                                      return _vm.update(
                                        "--" + entry.name,
                                        value
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8664450", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8664450","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/CommandComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b8664450","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/CommandComponent.vue
// module chunks = 0